import { SellerInfo as SellerInfoComponent } from 'components/sellers/SellerInfo/SellerInfo'
import { useParams } from 'react-router-dom'

export const SellerInfo: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  return <SellerInfoComponent mode='edit' type='seller' sellerId={id as string} />
}
